import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLabPartners } from '../../api/hooks';
import { useSession } from '../../app/session';
import { ErrorState, Loading, TableEmpty } from '../../components/States';

export function PartnersPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { orgs } = useSession();
  const labs = orgs.filter((o) => o.org_type === 'lab').map((o) => ({ id: o.org_id, name: o.org_name }));
  const { rows, isLoading, error } = useLabPartners(labs);
  const open = (name: string) => navigate(`/board?q=${encodeURIComponent(name)}`);

  return (
    <>
      <div className="page-head">
        <div>
          <h1>{t('lab.partners.title')}</h1>
          <p>
            {labs.length > 1
              ? t('lab.partners.subAll')
              : t('lab.partners.subOne', { name: labs[0]?.name ?? '' })}
          </p>
        </div>
      </div>
      {isLoading ? (
        <Loading />
      ) : error && !rows.length ? (
        <ErrorState error={error} />
      ) : !rows.length ? (
        <TableEmpty>{t('lab.partners.empty')}</TableEmpty>
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>{t('lab.partners.cols.clinic')}</th>
                <th>{t('lab.partners.cols.doctors')}</th>
                <th>{t('lab.partners.cols.inWork')}</th>
                <th>{t('lab.partners.cols.waiting')}</th>
                <th>{t('lab.partners.cols.late')}</th>
                <th>{t('lab.partners.cols.total')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr
                  key={r.org.id}
                  tabIndex={0}
                  onClick={() => open(r.org.name)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') open(r.org.name);
                  }}
                >
                  <td className="pname">«{r.org.name}»</td>
                  <td>
                    {r.doctors.length
                      ? r.doctors.map((d, i) => (
                          <span key={d.id}>
                            {i > 0 && <br />}
                            {d.name}
                          </span>
                        ))
                      : '—'}
                  </td>
                  <td>{r.in_work}</td>
                  <td>{r.waiting_doctor}</td>
                  <td>
                    {r.late ? <span className="tag late">{r.late}</span> : <span className="muted">0</span>}
                  </td>
                  <td>{r.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <p className="muted small">{t('lab.partners.hint')}</p>
    </>
  );
}
